<div class="flex flex-col flex-1 min-h-[calc(100vh_-_84px)] w-full"
  *transloco="let t; prefix: 'property-upload-wizard'">
  <ng-container [ngSwitch]="Step">
    <!-- Step 1 -->
    <ng-container *ngSwitchCase="'Step1'">
      <app-step-one class="h-full flex flex-col" [Steps]="Steps" (saveStepOne)="SaveStep1($event)"
        [data]="propertyUploadData">
      </app-step-one>
    </ng-container>

    <!-- Step 2 -->
    <ng-container *ngSwitchCase="'Step2'">
      <app-step-two
        [InitialLocation]="propertyUploadData.PropertyAddress"
        class="h-full flex flex-col"
        [Steps]="Steps"
        (previousButtonClicked)="GoTo('Step1')"
        (saveStepTwo)="SaveStep2($event)"
      >
      </app-step-two>
    </ng-container>

    <!-- Step 3 -->
    <ng-container *ngSwitchCase="'Step3'">
      <app-step-three class="h-full flex flex-col" [EncodedLocationBounds]="encodedLocationBounds"
        [PropertyData]="propertyUploadData" [Steps]="Steps" (saveStepThree)="SaveStep3($event)"
        (previousButtonClicked)="GoTo('Step2')"></app-step-three>
    </ng-container>

    <!-- Step 4 -->
    <!-- !IMPORTANT #45494: Hide select package step on asset update and preselect Uniko photography. Selected package on checkout should be modeled on cms along with package title.-->
    <!-- <ng-container *ngSwitchCase="'Step4'">
      <app-step-four [productSelection]="this.productListSelection" (saveStepFour)="SaveStep4($event)" [Steps]="Steps"
        (previousButtonClicked)="GoTo('Step3')"></app-step-four>
    </ng-container> -->

    <!-- Step 5 -->
    <ng-container *ngSwitchCase="'Step4'">
      <app-step-five
        [loading]="loading"
        [termsAccepted] = "this.termsAreAccepted"
        (saveStepFive)="SaveStep5()"
        (onConsestChange)="onChangeConsent($event)"
        (previousButtonClicked)="GoTo('Step3')"
        [Steps]="Steps"
      ></app-step-five>
    </ng-container>
  </ng-container>
</div>